import { CategoryEntity } from '@resident-select/domain/category';
import { createEntityEvent } from '../../../shared/base';
import { createAction, props } from '@ngrx/store';

export const CreatedCategoryEvent = createEntityEvent<CategoryEntity>('CreatedCategoryEvent');
export const GotAllCategoriesEvent = createAction('GotAllCategoriesEvent', props<{ entities: CategoryEntity[] }>());
export const UpdatedCategoryEvent = createEntityEvent<CategoryEntity>('UpdatedCategoryEvent');